import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { AlertTriangle, Phone } from 'lucide-react';

const Maintenance = ({ message }) => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' }}>
      <Card className="w-full max-w-md mx-4 border-green-200 shadow-xl">
        <CardContent className="pt-8 pb-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 mb-6">
              <AlertTriangle className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="text-2xl font-bold text-red-700 mb-4">System Under Maintenance</h1>
            <p className="text-gray-600 mb-6">
              {message || "We're currently performing scheduled maintenance to improve your experience. Please check back shortly."}
            </p>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-red-700">
                <strong>⚠️ Notice</strong><br />
                Our team is working to enhance the system. This won't take long.
              </p>
            </div>
            <div className="bg-green-50 border border-green-300 rounded-lg p-4">
              <p className="text-sm text-green-800 mb-2">
                <strong>Need immediate assistance?</strong>
              </p>
              <div className="flex items-center justify-center gap-2 text-green-700">
                <Phone className="w-5 h-5" />
                <a href="tel:0924745517" className="text-lg font-bold hover:underline">
                  0924745517
                </a>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Maintenance;
